export const INITIAL_STATUS_COLORS = {
  'POSTADO': 'bg-blue-600 text-white',
  'REVISAR': 'bg-cyan-300 text-slate-900',
  'EDIÇÃO': 'bg-purple-500 text-white',
  'AGUARDANDO': 'bg-slate-500 text-white',
  'VAZIO': 'bg-slate-700 text-transparent hover:bg-slate-600'
};

export const PRIORITY_COLORS = {
  'ENCERRADO': 'bg-slate-500 text-white',
  'ALTA': 'bg-red-500 text-white',
  'MÉDIA': 'bg-yellow-500 text-white',
  'BAIXA': 'bg-blue-400 text-white',
  'VAZIO': 'bg-slate-700 text-transparent hover:bg-slate-600'
};

export const GROUP_COLORS = [
  { id: 'c1', text: 'text-pink-500', border: 'border-l-pink-500', bg: 'bg-pink-500', hex: '#ec4899' },
  { id: 'c2', text: 'text-yellow-500', border: 'border-l-yellow-500', bg: 'bg-yellow-500', hex: '#eab308' },
  { id: 'c3', text: 'text-orange-500', border: 'border-l-orange-500', bg: 'bg-orange-500', hex: '#f97316' },
  { id: 'c4', text: 'text-green-500', border: 'border-l-green-500', bg: 'bg-green-500', hex: '#22c55e' },
  { id: 'c5', text: 'text-purple-500', border: 'border-l-purple-500', bg: 'bg-purple-500', hex: '#a855f7' },
  { id: 'c6', text: 'text-blue-500', border: 'border-l-blue-500', bg: 'bg-blue-500', hex: '#3b82f6' },
  { id: 'c7', text: 'text-cyan-500', border: 'border-l-cyan-500', bg: 'bg-cyan-500', hex: '#06b6d4' },
  { id: 'c8', text: 'text-red-500', border: 'border-l-red-500', bg: 'bg-red-500', hex: '#ef4444' },
];

export const INITIAL_CATEGORIES = [];

export const INITIAL_GROUPS = [];

export const INITIAL_COLUMNS = [
  { id: 'dataCriacao', title: 'Data Tarefa', type: 'readonly', width: 100 },
  { id: 'equipe', title: 'Equipe', type: 'people', width: 96 },
  { id: 'status', title: 'Status', type: 'status', width: 144 },
  { id: 'contrato', title: 'Contrato', type: 'text', width: 128 },
  { id: 'observacao', title: 'Observação', type: 'text', width: 192 },
  { id: 'extras', title: 'Extras', type: 'text', width: 96 },
  { id: 'prazo', title: 'Prazo', type: 'prazo', width: 80 },
  { id: 'entrega', title: 'Entrega', type: 'date', width: 96 },
  { id: 'priority', title: 'Prioridade', type: 'priority', width: 144 },
];

export const INITIAL_TASKS = [];

export const ALBUM_STATUS_COLORS = {
  'INICIAR PROJETO': 'bg-slate-600 text-white',
  'PROJETO FINALIZADO': 'bg-blue-500 text-white',
  'PROJETO EM APROVAÇÃO': 'bg-yellow-500 text-slate-900',
  'PROJETO APROVADO': 'bg-emerald-500 text-white',
  'ENVIADO PARA IMPRESSÃO': 'bg-purple-500 text-white',
  'IMPRESSÃO FINALIZADA': 'bg-cyan-500 text-slate-900',
  'MATERIAL PRONTO': 'bg-pink-500 text-white',
  'MATERIAL ENTREGUE': 'bg-slate-800 text-slate-400 border border-slate-600',
};

export const INITIAL_ALBUMS = [];

export const INITIAL_TASK_STATUS_CONFIG = {
  'POSTADO': { slaDays: 3, controlaPrazo: true },
  'REVISAR': { slaDays: 2, controlaPrazo: true },
  'EDIÇÃO': { slaDays: 5, controlaPrazo: true },
  'AGUARDANDO': { slaDays: 0, controlaPrazo: false },
  'VAZIO': { slaDays: 0, controlaPrazo: false }
};

export const INITIAL_THEME = {
  primaryBg: '#11131c',
  sidebarBg: '#181b26',
  textColor: '#e2e8f0',
  logoUrl: null,
  editorCanCreate: false,
  trackActivityLogs: true,
  paymentData: {
    pix: '',
    banco: '',
    agencia: '',
    conta: '',
    titular: '',
    documento: '',
    observacoes: '',
  },
  albumDeadlines: {
    'INICIAR PROJETO': 5,
    'PROJETO FINALIZADO': 2,
    'PROJETO EM APROVAÇÃO': 15,
    'PROJETO APROVADO': 3,
    'ENVIADO PARA IMPRESSÃO': 40,
    'IMPRESSÃO FINALIZADA': 2,
    'MATERIAL PRONTO': 5,
    'MATERIAL ENTREGUE': 0
  }
};
